module.exports = __webpack_public_path__ + "img/shipping-onboarding-example@1x.c97bab63.png";